// extracted by css-extract-rspack-plugin
export default {"text":"text--AaCn1B11YWsDOwu9"};